import { AccountType } from '@tassat/common-definitions';
import { AccountRecordExtended, WalletRecordExtended, WalletRecordMapped } from '@tassat/fred-extended-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import {
    getAccountClientGroups, getAccountPositions, getAccountRelationships, getAccounts
} from './common';

const getWalletAccountId = (_: AdminState | ClientState, walletAccountId: string) => walletAccountId || '';
const getAccountAccountId = (_: AdminState | ClientState, accountId: string) => accountId || '';

export const getLinkedAccountForWallet = createSelector(
    [ getAccountRelationships, getAccounts, getWalletAccountId ], (accountRelationshipsList, accounts, walletAccountId) => {
        const relatedAccounts = Object.keys(accountRelationshipsList)
            .map(id => accountRelationshipsList[id])
            .filter(relationship => relationship.AccountId2 === walletAccountId || relationship.AccountId1 === walletAccountId);

        return relatedAccounts.map(relation => {
            return Object.keys(accounts)
                .map(id => accounts[id])
                .find(account => (account.AccountId === relation.AccountId2 || account.AccountId === relation.AccountId1) &&
                    account.AccountTypeId === AccountType.CLIENT_BDA);
        });
    }
);

export const getAssociatedWalletsbyAccount = createSelector(
    [ getAccountRelationships, getAccounts, getAccountAccountId ], (accountRelationshipsList, accounts, AccountId) => {
        const relatedWallets = Object.keys(accountRelationshipsList)
            .map(id => accountRelationshipsList[id])
            .filter(relationship => relationship.AccountId1 === AccountId || relationship.AccountId2 === AccountId);

        return relatedWallets.map(relation => {
            return Object.keys(accounts)
                .map(id => accounts[id])
                .find(account => (account.AccountId === relation.AccountId2 || account.AccountId === relation.AccountId1) &&
                    account.AccountTypeId === AccountType.CLIENT_EOA);
        });
    }
);

export const getAssociatedWalletsMappedbyAccount = createSelector(
    [ getAccountRelationships, getAccounts, getAccountClientGroups, getAccountPositions, getAccountAccountId ],
    (accountRelationshipsList, accounts, accountClientGroups, accountPositions, AccountId) => {
        const relatedWallets = Object.keys(accountRelationshipsList)
            .map(id => accountRelationshipsList[id])
            .filter(relationship => relationship.AccountId1 === AccountId || relationship.AccountId2 === AccountId);

        const wallets = relatedWallets.map(relation => {
            return Object.keys(accounts)
                .map(id => accounts[id])
                .find(account => (account.AccountId === relation.AccountId2 || account.AccountId === relation.AccountId1) &&
                    account.AccountTypeId === AccountType.CLIENT_EOA);
        })
            .filter((wallet): wallet is AccountRecordExtended => Boolean(wallet));

        if (wallets.length) {
            return wallets.map((relation) => {
                const relatedAccounts = Object.keys(accountRelationshipsList)
                    .map(id => accountRelationshipsList[id])
                    .filter(relationship => relationship.AccountId2 === relation?.AccountId ||
                        relationship.AccountId1 === relation?.AccountId);

                const linkedAccount = relatedAccounts.map(relation => {
                    return Object.keys(accounts)
                        .map(id => accounts[id])
                        .find(account => (account.AccountId === relation.AccountId2 || account.AccountId === relation.AccountId1) &&
                            account.AccountTypeId === AccountType.CLIENT_BDA);
                });
                const linkedAccountPositions = Object.keys(accountPositions[relation.AccountId])
                    .map(id => accountPositions[relation.AccountId][id]);

                const relationWithAcg: WalletRecordExtended = {
                    ...relation,
                    ACGNumber1: accountClientGroups[relation.ACGId1] && accountClientGroups[relation.ACGId1].ACGNumber,
                    ACGNumber2: accountClientGroups[relation.ACGId2] && accountClientGroups[relation.ACGId2].ACGNumber,
                    ACGNumber3: accountClientGroups[relation.ACGId3] && accountClientGroups[relation.ACGId3].ACGNumber,
                    LinkedAccount: linkedAccount[0]
                };

                const mappedRecord: WalletRecordMapped = {
                    wallet: relationWithAcg,
                    walletStats: linkedAccountPositions
                };

                return mappedRecord;
            });
        } else return {
            wallet: undefined,
            walletStats: undefined
        };
    }
);